export default {
    namespaced: true,
    plane: {
      title: "Plane",
      add: "Add",
      name: "Name",
      instructions: "Instructions",
      devices: "Devices",
      maintenance: "Maintenance",
      maintenance_partial: "Under partial maintenance",
      maintenance_total: "Under full maintenance",
      image: "Drag an image",
      add_device: "To text or device to add to plan",
      move_plane: "Hold to move flat",
      rotate_device: "Hold to rotate device",
      no_floor_plant: "You don't have any floor plant for this facility",
      no_floor_plant_permission: "You do not have permission to view this facility's floor plans",
      floor_plant_load_error: "The facility's floor plans could not be loaded",
      floor_plant_context_missing: "The alarm's facility could not be identified",
      button_text: "Click here for setup a floor plant for this facility",
    },
}
